import {
  getLeoUuid,
  LeoUUID,
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { RespondentColumnDetails, RespondentColumnDetailsDTO } from "../types/respondentColumnDetails";
/* eslint-disable import/export */
export abstract class GetRespondentColumnNamesRPC implements
  LeoRPC<GetRespondentColumnNamesRPC.Request, GetRespondentColumnNamesRPC.Response, GetRespondentColumnNamesRPC.Errors.Errors>
{
  abstract execute(
    request: GetRespondentColumnNamesRPC.Request
  ): Promise<LeoRPCResult<GetRespondentColumnNamesRPC.Response, GetRespondentColumnNamesRPC.Errors.Errors>>;
}

export namespace GetRespondentColumnNamesRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    projectId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetRespondentColumnNamesRPCRequest: boolean = true;
  
    readonly projectId: LeoUUID;
  
  
    constructor(
    projectId: LeoUUID
    ) {
      this.projectId = projectId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const projectId = getLeoUuid(dto, "projectId", InvalidRequestProjectIdError);
      return new Request(
        projectId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          projectId: this.projectId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetRespondentColumnNamesRPC(projectId='${this.projectId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    respondentColumnDetails: RespondentColumnDetailsDTO[];
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetRespondentColumnNamesResponse: boolean = true;
  
    readonly respondentColumnDetails: RespondentColumnDetails[];
  
  
    constructor(
    respondentColumnDetails: RespondentColumnDetails[]
    ) {
      this.respondentColumnDetails = respondentColumnDetails;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const respondentColumnDetails = getList<RespondentColumnDetailsDTO, RespondentColumnDetails>(
        dto,
        "respondentColumnDetails",
        RespondentColumnDetails.fromDTO,
        InvalidResponseRespondentColumnDetailsError
      );
      return new Response(
        respondentColumnDetails
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          respondentColumnDetails: this.respondentColumnDetails.map((e: RespondentColumnDetails) => { return e.toDTO() })
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetRespondentColumnNames(respondentColumnDetails='${this.respondentColumnDetails}')`;
  };
  

  export enum RPCError {
    InvalidProjectId = "INVALID_PROJECT_ID"
  }

  export namespace Errors {
    
    export interface InvalidProjectIdDTO {
      code: string;
    }
    
    export class InvalidProjectId extends LeoRPCError<RPCError> {
      readonly isInvalidProjectId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidProjectId;
        super(code);
      }
    
    
      toDTO(): InvalidProjectIdDTO {
        const dto: InvalidProjectIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidProjectId.prototype.toString = function toString(): string {
      return `GetRespondentColumnNamesRPC.INVALID_PROJECT_ID()`;
    };
    

    export type Errors = InvalidProjectId;
    export type ErrorsDTO = InvalidProjectIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidProjectId:
          return new InvalidProjectId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestProjectIdError extends GetRespondentColumnNamesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestProjectIdError";
  }
}

export class InvalidResponseRespondentColumnDetailsError extends GetRespondentColumnNamesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseRespondentColumnDetailsError";
  }
}

export class InvalidResponseInvalidProjectIdError extends GetRespondentColumnNamesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidProjectIdError";
  }
}

